import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import React, { useEffect } from "react";

function QueryPreview(props: any) {
  const [openPreviewDialog, setOpenPreviewDialog] = React.useState(false);
  const [rows, setRows] = React.useState<any[]>([]);
  const [rowId, setRowId] = React.useState<string | number>("id");
  const [, setPreviewString] = React.useState<string>("");
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  const vyu_service_url = process.env.REACT_APP_VYU_SERVICE_URL;
  const [columns, setColumns]: any[] = React.useState<GridColDef[]>([]);
  const handlePreviewClose = () => {
    console.log("Entered handlePreviewClose");
    props.onclose();
    setColumns([]);
    setRows([]);
    setRowId("id");
    setOpenPreviewDialog(false);
  };
  useEffect(() => {
    setColumns([]);
    setRows([]);
    setRowId("id");
    console.log("setColumns", columns);
    console.log("setRows", rows);
    console.log("props.queryId", props.queryId);
    if (props.open === true) {
      setOpenPreviewDialog(true);
      if (
        props.queryId !== undefined &&
        props.queryId !== null &&
        props.queryId !== "null"
      ) {
        handlePreview(props.queryId);
      }
    }
    async function handlePreview(id: any) {
      var colsValue;
      var rowValue;
      let tokenStr = localStorage.getItem("token");
      const contextValue = "queryPreview";
      fetch(
        `${vyu_service_url}/getPreviewData?queryId=${id}&context=${contextValue}`,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
          method: "GET",
        }
      )
        .then((response) => response.json())
        .then((json) => {
          let tempArr = json.obj;
          console.log("tempArr in query", tempArr);
          if (!tempArr) {
            setColumns([]);
            setRows([]);
            return;
          } else {
            // Replace null values with empty string
            tempArr = tempArr.map((row: Record<string, any>) =>
              Object.fromEntries(
                Object.entries(row).map(([key, value]) => [key, value ?? ""])
              )
            );
            let cols: GridColDef[] = [];
            let columnElement: any = {};
            for (let key of Object.keys(tempArr[0])) {
              columnElement = {
                field: key,
                headerName: key.toUpperCase(),
                type: typeof key,
                width: 150,
              };
              cols.push(columnElement);
            }
            colsValue = cols;
            rowValue = tempArr;
            setColumns(cols);
            setRows(tempArr);
            // setQueryData({cols:columns,rows:rows})
            setRowId(columnElement.field);
          }
        });
      return { cols: colsValue, rows: rowValue };
    }
  }, [props]);

  return (
    <>
      <Dialog
        open={openPreviewDialog}
        keepMounted
        onClose={handlePreviewClose}
        maxWidth="xl"
      >
        <DialogTitle>{"Query Preview"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {/* <div className="justify-center text-blue-600 ">
              <h3>{previewString}</h3>
            </div> */}
            <div
              style={{ width: `${columns.length * 350}px`, overflowX: "auto" }}
            >
              <DataGrid
                rows={rows}
                autoHeight
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: { page: 1, pageSize: 5 },
                  },
                }}
                pageSizeOptions={[5, 10, 20]}
                // checkboxSelection
                getRowId={(row) => row[rowId]}
              />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Disagree</Button> */}
          <Button variant="outlined" onClick={handlePreviewClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default QueryPreview;
